import { useState } from "react";
import "./privacyandpolicy.css"; // you can rename it to privacy-policy.css if needed
import Maincard from "../../comman/maincard";
import SEO from "../../comman/SEO";

const PrivacyPolicyPage = () => {

   const privacyPolicy = [
    {
        question: "Introduction",
        answer: [
            "Vaikunta Maha Ruchulu (“we”, “us”, or “our”) respects your privacy and is committed to protecting your personal information. This Privacy Policy describes how we collect, use, and safeguard your information when you visit our website (vaikuntamaharuchulu.com), place an order, or interact with us."
        ],
    },
    {
        question: "Information We Collect",
        answer: [
            "We may collect the following types of information:",
            "- Name, phone number, email address, and delivery address when placing orders, reservations, or contacting us.",
            "- Information about your visit to the website, such as pages visited, browser details, and device type (collected via cookies or analytics tools).",
            "- Other information you choose to provide in feedback forms or communication."
        ],
    },
    {
        question: "How We Use Your Information",
        answer: [
            "Your information may be used for:",
            "- Processing orders, reservations, and responding to inquiries.",
            "- Improving our services, website, and customer experience.",
            "- Sending notifications, confirmations, or occasional promotional messages (with your consent).",
            "- Fulfilling legal, regulatory, or safety obligations."
        ],
    },
    {
        question: "How We Share Your Information",
        answer: [
            "We do not sell or rent your personal data to third parties.",
            "We may share your information with trusted service providers (like payment processors or delivery partners) only to fulfill your order.",
            "Personal data may be shared if required by law, regulation, or for safety/security reasons."
        ],
    },
    {
        question: "Data Security",
        answer: [
            "We take appropriate measures to protect your personal data from unauthorized access, alteration, or disclosure, using secure servers and reasonable technical safeguards."
        ],
    },
    {
        question: "Cookies and Tracking",
        answer: [
            "Our website may use cookies and analytics technologies to improve user experience and analyze traffic. You can adjust your browser settings to refuse non-essential cookies."
        ],
    },
    {
        question: "Data Retention",
        answer: [
            "We retain your information only as long as necessary for the purposes set out in this policy, unless longer retention is required by law."
        ],
    },
    {
        question: "Your Rights",
        answer: [
            "You may:",
            "- Request details, correction, or deletion of your personal data held with us.",
            "- Opt out of promotional communications at any time by contacting us."
        ],
    },
    {
        question: "Children’s Privacy",
        answer: [
            "We do not knowingly collect information from children under 13. If you believe a child has provided us personal information, please contact us to have it removed."
        ],
    },
    {
        question: "Changes to This Policy",
        answer: [
            "We may update this Privacy Policy from time to time. Please check this page for the latest version."
        ],
    },
    {
        question: "Contact Us",
        answer: [
            "For privacy questions, data requests, or concerns, reach us via the Contact page or call 7900368003."
        ],
    }
];


    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
        <SEO
            title="privacy and policies | Vaikunta Maha Ruchulu - Pure Veg Restaurant in Vizag  "
            description="Read the privacy policy for Vaikunta Maha Ruchulu, vizag trusted pure veg restaurant. learn how to protect your personal data and information."
            keywords=" Vaikunta Maha Ruchulu privacy policy, 
            vizag pure veg restaurant data policy, 
            customer data protection,
            secure data handling by vaikunta maharuchulu,
            trusted pure veg dining in Vizag privacy practices,
            customer data protection standards"  />
            <div>
                <Maincard
                    image={"assets/privacy.jpg"} // you can use a privacy-related image
                    title={"PRIVACY AND POLICY"}
                />
            </div>

            <div className="faq-container">
                <h1 className="faq-title">Vaikunta Maha Ruchulu – Privacy Policy</h1>
                <div className="faq-list">
                    {privacyPolicy.map((item, index) => (
                        <div key={index} className="faq-item">
                            <button
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                            >
                                <span>{item.question}</span>
                                <span className="faq-icon">{openIndex === index ? "−" : "+"}</span>
                            </button>
                            {openIndex === index && (
                                <div className="faq-answer">
                                    {item.answer.map((text, idx) => (
                                        <p key={idx}>{text}</p>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicyPage;
